import teamlove from "@/assets/images/products/project-pulse/whychoose.webp";

import retail from "@/assets/images/services/uiux/retail.webp";
import fintech from "@/assets/images/services/uiux/fintech.webp";
import healthcare from "@/assets/images/services/uiux/healthcare.webp";
import logistics from "@/assets/images/services/uiux/logistics.webp";
import edTech from "@/assets/images/services/uiux/edTech.webp";
import ecommerce from "@/assets/images/services/uiux/e-commerce.webp";


import reality from "@/assets/icons/services/uiux/reality.svg";
import clarity from "@/assets/icons/services/uiux/clarity.svg";
import experience from "@/assets/icons/services/uiux/experience.svg";
import user from "@/assets/icons/services/uiux/user.svg";
import build from "@/assets/icons/services/uiux/build.svg";

import application from "@/assets/images/services/uiux/application.webp";

import figma from "@/assets/images/services/uiux/figma.webp";
import hotjar from "@/assets/images/services/uiux/hotjar.webp";
import maze from "@/assets/images/services/uiux/maze.webp";
import framer from "@/assets/images/services/uiux/framer.webp";
import webflow from "@/assets/images/services/uiux/webflow.webp";
import miro from "@/assets/images/services/uiux/miro.webp";

const interaction = "/assets/videos/services/uiux/Interaction.webm";
const design = "/assets/videos/services/uiux/Design.webm";
const mobileApp = "/assets/videos/services/uiux/MobileApp.webm";
const identity = "/assets/videos/services/uiux/Identity.webm";
const audit = "/assets/videos/services/uiux/Audit.webm";
const analysis = "/assets/videos/services/uiux/Analysis.webm";
const prototyping = "/assets/videos/services/uiux/Prototyping.webm";

const uiUxServices = {
  "ui-ux-design": {
    slug: "ui-ux-design",
    name: "Ui UX Design",
    hero: {
      title: "Modern UI/UX Design Services for Growing Businesses ",
      description:
        "We create intuitive, high-converting UI/UX that feels natural from the first interaction. Every screen is designed to guide users, reduce friction, and drive real results. ",
    },

    product: {
      title: "Design That Works at Every Product",
      subtitle:
        "Research-driven design built for real-world use, focused on usability, consistency, and scalable user experiences.",
      features: [
        {
          title: "UX Research & User Analysis ",
          description:
            "Learn what users actually want through research, data, and insight-driven decisions. ",
          image: analysis,
        },
        {
          title: "Wire framing & Prototyping ",
          description:
            "Sketch, test, and validate early with interactive prototypes before development. ",
          image: prototyping,
        },
        {
          title: "UI Design & Visual Identity ",
          description:
            "Consistent, polished interfaces that reflect your brand across every device. ",
          image: identity,
        },
        {
          title: "UX Audit & Redesign ",
          description:
            "We identify user friction, conversion gaps, and fix them fast. ",
          image: audit,
        },
        {
          title: "Mobile App Design (iOS & Android) ",
          description:
            "We follow platform conventions while designing apps that stand out in the store. ",
          image: mobileApp,
        },
        {
          title: "Design System Creation ",
          description:
            "We build scalable, documented design systems your team can reuse for years. ",
          image: design,
        },
        {
          title: "Interaction Design & Micro-Animations ",
          description:
            "Delight comes from thoughtful micro-interactions and smooth transitions. ",
          image: interaction,
        },
      ],
    },

    whyChoose: {
      title: "Why Our Work Performs Better ",
      description:
        "Design focused on user behavior and conversions, built with clarity, tested fast, and structured to scale beyond just visuals. ",
      image: teamlove,
      cases: [
        {
          title: "Every design is backed by user behavior",
        },
        {
          title: "Focus on conversions, not just visuals ",
        },
        {
          title: "Fast iteration with real testing ",
        },
        {
          title: "Developer-ready output (no handoff confusion) ",
        },
        {
          title: "Systems thinking, not random screens",
        },
        {
          title: "Built for scalability, not one-off designs ",
        },
      ],
    },

    structuredDesignData: {
      title: "Structured Design That Brings Clarity",

      description:
        "We move from discovery to delivery through structured research, testing, and design - ensuring every decision is validated before development begins.",

      image: application,
      cards: [
        {
          icon: reality,
          title: "Understand the Reality",
          description:
            "Stakeholder interviews, audits, and benchmarks to understand users before designing.",
        },
        {
          icon: clarity,
          title: "Turn Insight into Clarity",
          description:
            "User journeys, personas, and problem statements that bring clarity before design.",
        },
        {
          icon: experience,
          title: "Build the Experience",
          description:
            "Wireframes to high-fidelity screens with motion specs and 3 design directions.",
        },
        {
          icon: user,
          title: "Validate with Users",
          description:
            "Usability testing with real users to identify issues before development.",
        },
        {
          icon: build,
          title: "Ready for Build",
          description:
            "Developer-ready Figma files, annotations, and 30-day post-launch support.",
        },
      ],
    },

    cta: {
      title: "Proven Impact We’ve Delivered ",
      description:
        "We design user-first experiences that combine clarity, usability, and strong visual design to improve product outcomes. ",
      buttonText: "Let's Talk",
    },

    impact: {
      title: "Where AI Creates Immediate High Impact",
      description:
        "AI creates the fastest value when applied to areas that already consume time, create delays, or depend heavily on repetitive effort.",
      cases: [
        {
          title: "Figma",
          image: figma,
        },
        {
          title: "Framer",
          image: framer,
        },
        {
          title: "Maze",
          image: maze,
        },
        {
          title: "Hotjar",
          image: hotjar,
        },
        {
          title: "Miro",
          image: miro,
        },
        {
          title: "Webflow ",
          image: webflow,
        },
      ],
    },

    design: {
      title: "Design Tailored for Every Industry ",
      description:
        "We don't just design interfaces; we understand the user's psychology, compliance constraints, and conversion dynamics of each sector. ",
      features: [
        {
          image: retail,
          title: "Retail ",
          description: "POS, inventory, loyalty apps ",
        },
        {
          image: fintech,
          title: "Fintech",
          description:
            "Adapts to your existing business processes instead of forcing you to change how you work.",
        },
        {
          image: healthcare,
          title: "Healthcare",
          description:
            "Automates repetitive tasks to save time, reduce errors, and improve overall efficiency.",
        },
        {
          image: logistics,
          title: "Logistics",
          description:
            "Easily modify features and workflows without heavy development or long delays.",
        },
        {
          image: edTech,
          title: "EdTech",
          description:
            "Stay connected and manage your business anytime, anywhere from any device.",
        },
        {
          image: ecommerce,
          title: "E-Commerce",
          description:
            "Advanced security measures ensure your business data remains safe, private, and reliable.",
        },
      ],
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "Questions We Get Before the First Call ",
          answer:
            "Smart, skeptical decision-makers ask great questions. Here are the ones we hear most often, answered honestly. ",
        },
        {
          question: "Do we retain full ownership of all design files? ",
          answer:
            "Yes. All Figma files, assets, and design systems are fully yours after final payment, no lock-in or hidden rights. ",
        },
        {
          question: "How long does a typical UX/UI design project take? ",
          answer:
            "Typically, 4–16 weeks depending on scope. UX audits take 1–2 weeks, full product design 8–16 weeks. We share a clear timeline upfront. ",
        },
        {
          question: "How many revision rounds are included? ",
          answer:
            "We focus on alignment, not revision limits. Issues are resolved early through structured design stages, minimizing major changes later. ",
        },
        {
          question: "Can you work within our existing design system?  ",
          answer:
            "Yes. We review your current system, improve gaps if needed, and work directly within your existing Figma setup. ",
        },
      ],
    },

    contact: {
      title: "Ready to Design Something That Actually Works? ",
      description:
        "Tell us about your project. We'll get back within 24 hours with real thoughts, no pitch deck, no pressure, no sales call disguised as a discovery call. ",
      features: [
        "Free initial consultation ",
        "NDA available before discovery ",
        "Response within 24 hours ",
        "Consistent design team throughout ",
        "You own all files and deliverables ",
      ],
    },
  },
};
export default uiUxServices;
